import { BASE } from "src/common/constants";
import { logoutSession } from "src/helpers/rest";

const API: string = BASE.API_HOST;
const INVALID_TOKEN: string = 'Missing or invalid access token';
const POST = 'post', GET = 'get', PUT = 'put', PATCH = 'patch', DELETE = 'delete';

const getToken = (): string => localStorage.getItem('token') || '';

const handleResponse = async (response: Response): Promise<any> => {
    if (!response.ok) {
        const parsedError = await response.json();
        handleTokenError(parsedError);
        return Promise.reject(parsedError);
    }
    const contentType: string | null = response.headers.get('Content-Type');
    return (contentType && contentType.indexOf('application/json') !== -1)
        ? response.json()
        : response.text();
};

const Request = async (route: string, method: string, priv: boolean = true, payload?: any): Promise<any> => {
    const headers: HeadersInit = {
        'content-type': 'application/json'
    };

    if (priv) {
        const token: string = getToken();
        if (!token) {
            localStorage.clear();
            window.location.reload();
        }
        headers['Authorization'] = 'Bearer ' + token;
    }

    const config: RequestInit = {
        method: method,
        headers: headers,
        body: ['post', 'put', 'patch'].includes(method) ? JSON.stringify(payload) : undefined
    };

    try {
        const response: Response = await fetch(`${API}${route}`, config);
        return await handleResponse(response);
    } catch (err) {
        console.log(err);
        throw err;
    }
};

const RequestWithToken = async (route: string, method: string, token: string, payload?: any): Promise<any> => {
    const headers: HeadersInit = {
        'content-type': 'application/json'
    };

    if (!token) {
        localStorage.clear();
        window.location.reload();
    }
    headers['Authorization'] = 'Bearer ' + token;

    const config: RequestInit = {
        method: method,
        headers: headers,
        body: ['post', 'put', 'patch'].includes(method) ? JSON.stringify(payload) : undefined
    };

    try {
        const response: Response = await fetch(`${API}${route}`, config);
        return await handleResponse(response);
    } catch (err) {
        console.log(err);
        throw err;
    }
};

const handleTokenError = (err: any): any => {
    if (err?.error === 'Unauthorized' || err?.status === 401 || err?.error === INVALID_TOKEN) {
        logoutSession()
    }
    return err;
};

export {
    Request,
    RequestWithToken,
    POST, GET, PUT, DELETE, PATCH
};
